<template>
  <div id="bdm_message" :class="isFull === 1 ? 'bdm_message top_information1' : ' bdm_message'">
    <!-- Top Navigation Bar -->
    <van-nav-bar
      :title="$t('column.bdm_messages')"
      placeholder
      fixed
      left-arrow
      @click-left="onClickLeft"
    >
      <template #right>
        <span class="clear-btn" @click="clearMessages">{{ $t('column.clear_up') }}</span>
      </template>
    </van-nav-bar>

    <!-- Message Content Area -->
    <div class="message-container">
      <div class="message-list" v-for="item in list" :key="item.id">
        <!-- A single message item -->
        <div class="message-time">{{ item.time }}</div>
        <div class="message-item">
          <!-- Avatar -->
          <div class="message-avatar">
            <img src="@/assets/img/bdm/bd_message_img.png">
          </div>
          
          <!-- Message Bubble -->
       
          <div class="message-content">
               <div class="message-title" v-if="item.title">{{ item.title }}</div>
               <div>{{ item.content }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import '@/assets/css/style.css'
import axios from "axios";
import { Dialog, Toast } from 'vant';
export default {
  name: 'bdm_message',
  data() {
    return {
      // Data properties can be added here
        list: [],
        loading: false,
        finished: false,
        page: 1,
        isFull: 0, // is_full=1 全屏显示信号栏 0 非全屏显示信号栏
    };
  },
   created() {
    this.isFull = this.$route.query.is_full == 1 ? 1 : 0 // is_full=1 显示信号栏
    this.get_list()
  },
  methods: {
      get_list(){
        this.loading = true
        const token = this.$route.query.token
        axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=system_bdm&act=get_message_list",{ params:{token: token }}).then(res =>{
            console.log(res)
            // 加载状态结束
            this.loading = false
            if (this.page === 1) {
                this.list = []
            }
            for (let j = 0; j < res.data.data.list.length; j++) {
                this.list.push(res.data.data.list[j])
            }
            //如果列表数据条数< 0，不再触发滚动加载
            if (res.data.data.list.length <= 0) {
                this.finished = true
            }
            this.page ++
        })
    },
    onClickLeft() {
      this.$router.go(-1);
    },
    clearMessages() {
      // Handle clear messages logic here
       Dialog.confirm({
        message: this.$t('column.confirm_clear_up'),
        confirmButtonText: this.$t('btn.confirm'),
        cancelButtonText: this.$t('btn.cancel'),
      }).then(() => {
        const token = this.$route.query.token
        axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=system_bdm&act=clear_bdm_message", {
          params: {
            token: token,
          }
        }).then(res => {
            Toast(res.data.error)
            if (res.data.status === 1) {
                this.list = []
                this.page = 1
                this.finished = false
                this.get_list()
            }
        })

      })
      console.log('Clear messages clicked');
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/bdm_message.vue